import { useEffect, useMemo, useCallback } from 'react';
import { useStepupContext } from '../context/stepup-context';
import { useStepupSourceContext } from '../context/stepup-source';

import { hoursToMs } from '@wwe-portal/utils/date';
import { usePostStepupLaunchTime } from '@wwe-portal/web/providers/queries/stepup.mutation';

export const useAutoOpenModal = () => {
  const {
    isModalOpen,
    openModal,
    claimedItems,
    availableItems,
    modalClosedAt,
    clearModalClosedAt,
  } = useStepupContext();
  const { launchHistory, stepupInfo } = useStepupSourceContext();
  const { mutate: rawMutate } = usePostStepupLaunchTime();
  const mutate = useCallback((stepsUpId) => rawMutate(stepsUpId), [rawMutate]);
  const launchTimes = launchHistory?.launchTimes;
  const updatedAt = launchHistory?.updatedAt;
  const maxLaunchTimes = stepupInfo.launchTimes;
  const timeBetweenTwoLaunchInHour = stepupInfo.slotTimer;
  const stepsUpId = stepupInfo.stepsUpId;

  const shouldOpen = useMemo(() => {
    const now = Date.now();
    // If data is not avaialble, do not open
    if (launchTimes == null || updatedAt == null || !stepupInfo || isModalOpen)
      return false;

    const msTimeBetweenTwoLaunch = hoursToMs(timeBetweenTwoLaunchInHour);
    const intervalHasReset =
      Date.parse(updatedAt) + msTimeBetweenTwoLaunch <= now;

    // Clear modalClosedAt when interval has reset
    if (intervalHasReset && modalClosedAt) {
      clearModalClosedAt();
    }

    return (
      launchTimes <= maxLaunchTimes &&
      claimedItems < availableItems &&
      intervalHasReset
    );
  }, [
    modalClosedAt,
    isModalOpen,
    updatedAt,
    stepupInfo,
    launchTimes,
    maxLaunchTimes,
    timeBetweenTwoLaunchInHour,
    claimedItems,
    availableItems,
    clearModalClosedAt,
  ]);

  useEffect(
    () => {
      if (!mutate || !openModal || !shouldOpen || !updatedAt) return;
      openModal();
      mutate(stepsUpId);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [shouldOpen, stepsUpId, updatedAt]
  );
};
